// authSession.js
import { Auth } from 'aws-amplify';
import { authenticationService } from './';

const SKEW_SECONDS = 60;   // refresh 1 min early
let refreshInFlight = null;

export async function getValidSession({ allowNull = true } = {}) {
  try {
    const session = await Auth.currentSession(); // auto-refresh if needed
    const now = Math.floor(Date.now() / 1000);
    const accessExp = session.getAccessToken().getExpiration();

    if (accessExp - SKEW_SECONDS > now) return session;
    return await explicitRefresh(session);
  } catch (e) {
    // Amplify throws this when no user is signed in yet / at all
    if (allowNull && String(e?.message || e) === 'No current user') return null;
    throw e;
  }
}

export async function explicitRefresh(existingSession) {
  if (!refreshInFlight) {
    refreshInFlight = (async () => {
      try {
        const sess = existingSession || (await Auth.currentSession());
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

        await new Promise((resolve, reject) => {
          user.refreshSession(sess.getRefreshToken(), err => (err ? reject(err) : resolve()));
        });

        const newSession = await Auth.currentSession();

        // Extract expiration timestamps (Unix seconds → readable date)
        const jwtToken = newSession.getIdToken().getJwtToken();
        const idTokenExp = newSession.getIdToken().getExpiration();
        const accessTokenExp = newSession.getAccessToken().getExpiration();

        const idTokenExpDate = new Date(idTokenExp * 1000).toLocaleString();
        const accessTokenExpDate = new Date(accessTokenExp * 1000).toLocaleString();

        console.log("[authSession] 🆕 New Cognito session created", {
          jwtToken: jwtToken,
          jwtTokenExp: idTokenExpDate, // human readable expiration
          idTokenExp,
          accessTokenExp,
          refreshedAt: new Date().toISOString(),
        });

        if (authenticationService.setCurrentUser) {

          localStorage.setItem('currentUser', JSON.stringify(newSession.getIdToken()));
          authenticationService.setCurrentUser(newSession.getIdToken());

          // authenticationService.setCurrentUser({
          //   idToken: newSession.getIdToken().getJwtToken(),
          //   accessToken: newSession.getAccessToken().getJwtToken(),
          //   refreshToken: newSession.getRefreshToken().getToken(),
          //   payload: newSession.getIdToken().decodePayload(),
          //   accessPayload: newSession.getAccessToken().decodePayload(),
          // });
        }

        return newSession;
      } finally {
        refreshInFlight = null;
      }
    })();
  }
  return refreshInFlight;
}
